import { API, Auth } from "aws-amplify";
import BasePaths from "../constants/basePaths";

const { PMS_BASE, UTILITIES_BASE } = BasePaths;
const API_NAME = "WebeeAPI";

export const fetchPmslistforWeBeePass = async (hotelId) => {
  if (!Auth.userPool) return;

  let path = `${PMS_BASE}/getpmslist/${hotelId}`;
  return await API.get(API_NAME, path);
};

export const sendSMSForWeBeePassShortLink = async ({ phone_number, email, hotelName, shortLink }) => {
  if (!Auth.userPool) return;

  const path = `${UTILITIES_BASE}/linkSMSSender`;
  const myInit = {
    body: {
      phone_number, email, shortLink, hotelName
    }
  };
  return await API.post(API_NAME, path, myInit);
};

export const sendEmailForWeBeePassShortLink = async ({ language, shortener, hotelName, emails }) => {
  if (!Auth.userPool) return;

  const path = `${UTILITIES_BASE}/sendLinkEmail`;
  const myInit = {
    headers: { language },
    body: {
      description: "",
      details: {
        message: `
                  <b>Welcome to ${hotelName},</b>
                  <p>We’re excited to have you onboard! Please follow the two steps below to activate your guest account and start using it right away:</p>
                  <ol>
                      <li>Download our app <a href="${shortener.data.body.url_short}" target="_blank">here</a>.</li>
                      <li>Once the download is completed, <a href="${shortener.data.body.url_short}" target="_blank">click here</a> to activate your existing membership.</li>
                  </ol>
                  <p>If you need any further assistance, please contact the Front Office of the hotel.</p>
                `
      },
      recipients: emails,
      subject: `${hotelName} Application`,
      title: `${hotelName} Application`
    }
  };
  return await API.post(API_NAME, path, myInit);
};
